import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export default function DesativarMercadoInternacionalDialog({
  open,
  onClose,
  onConfirm,
}: Props) {
  const [desativando, setDesativando] = useState(false);

  const confirmar = async () => {
    setDesativando(true);
    try {
      await onConfirm();
    } finally {
      setDesativando(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle color="text.primary" sx={{ typography: "h3" }}>
        Desativar mercado internacional?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Você possui operações internacionais cadastradas. Ao desativar, os
          próximos cálculos serão bloqueados até reativar a funcionalidade em
          Conta › Preferências.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={desativando}>
          Cancelar
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={desativando}
          onClick={confirmar}
        >
          Desativar mesmo assim
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
